import { APP_CONSTANTS } from '../constants/enum.constants';
import { PlaceValue } from '../constants/types.constants';

export const getPrecision = (num: number): number => {
    if (!num) num = 0;
    let calculatedPrecision!: number;
    if (Math.floor(num) === num) calculatedPrecision = 0;
    else {
        if (num.toString().includes('e')) {
            const numInString: string = num?.toFixed(8) ?? '';
            calculatedPrecision = numInString.split('.')[1]?.length || 8;
        } else calculatedPrecision = num.toString()?.split('.')[1]?.length || 2;

        /* If precision exceeds 8, then return 8 */
        calculatedPrecision = calculatedPrecision > 8 ? 8 : calculatedPrecision;
    }
    return calculatedPrecision;
};

export const getPlaceValue = (num: number): PlaceValue => {
    let placeValue: PlaceValue = 'hundred';
    if (num > +APP_CONSTANTS.ONE_BILLION) placeValue = 'billion';
    else if (num > +APP_CONSTANTS.ONE_MILLION) placeValue = 'million';
    else if (num > +APP_CONSTANTS.ONE_THOUSAND) placeValue = 'thousand';
    else placeValue = 'hundred';
    return placeValue;
};

export const openUrlInNewTab = (url: string): void => {
    // document = inject(DOCUMENT);
    // const linkElement = document.createElement('a');
    // linkElement.target = '_blank';
    // linkElement.href = url;
    // linkElement.click();
    // linkElement.remove();
    window.open(url, '_blank');
};
